import React from 'react';
import Button from '@components/shared/buttons/Button/Button';
import styles from './SectionToggle.module.scss';

export interface ISection {
   id: string;
   text: string;
 }

 interface ISectionToggleProps {
   className?: string;
   sections: ISection[];
   activeSection: string;
   onSectionChange?: (sectionId: string) => void;
 }

const SectionToggle = ({
  sections,
  activeSection,
  onSectionChange = () => {},
}: ISectionToggleProps) => {
  return (
    <div className={ styles.SectionToggle }>
      {sections.map((section) => {
        if (section.id === activeSection) {
          return (
            <Button
              key={section.id}
              className={ `${styles.ToggleButton} ${styles.FirstToggle}` }
              type="button"
            >
              { section.text }
            </Button>
          );
        } else {
          return (
            <button
              type="button"
              key={section.id}
              className={ `${styles.ToggleLink} ${styles.FirstToggle}` }
              onClick={ () => onSectionChange(section.id) }
            >
              { section.text }
            </button>
          );
        }
      })}
    </div>
  );
};

export default SectionToggle;
